<template>
  <v-layout class="justify-center">
    <v-card>
      <br>
      <img src="@/assets/slip.png">
      <v-card-title primary-title>
        <div >
          <h3 class="headline">Boleto Bancário</h3>
          <p>Gere um boleto de qualquer valor para creditar sua conta digital</p>
        </div>
      </v-card-title>
      <v-card-actions>
        <v-btn dark block color="orange" @click="newSlipModalForm">
          &nbsp;Gerar Boleto&nbsp;
        </v-btn>
      </v-card-actions>
    </v-card>
    <self-slip-recharge/>
  </v-layout>
</template>

<script>
import { EventBus } from '@/services/event-bus';

export default {
  name: 'SlipRecharge',
  components: {
    selfSlipRecharge: () => import('@/components/recharge/actions/SelfSlipRecharge.vue'),
  },
  methods: {
    newSlipModalForm() {
      EventBus.$emit('show-self-slip-recharge');
    },
  },
};
</script>
